<template>
  <el-container>
    <el-aside class="app_aside">
      <div class="app_logo">
        <img src="../assets/logo.png" alt="">
      </div>
      <MyAside :asideId="app_asideId"></MyAside>
    </el-aside>
    <el-container>
      <el-header>
        <MyHeader></MyHeader>
      </el-header>
      <div class="app_con">

        <div class="app_Rig">
          <div class="app_TNav">
            <div class="app_TList">
              <div class="app_TItem"
                   v-for="(todo, index) in todos"
                   :class="{ app_TAct: activeTabIndex === index }"
                   @click="switchTab(index)">
                {{todo.title}} <i class="el-icon-close" @click.stop="removeTodo(index)" v-if="index>0"></i>
              </div>
            </div>
          </div>
          <el-main>
            <div class="taskTop">
              <div class="taskFrom">
                <el-form ref="taskFrom" :model="taskFrom" label-width="80px">
                  <el-form-item label="关键词:" class="taskItem">
                    <el-input v-model="taskFrom.name"
                              placeholder="任务编号/需求描述"></el-input>
                  </el-form-item>
                  <el-form-item label="类型:" class="taskItem">
                    <el-select v-model="taskFrom.type" placeholder="请选择">
                      <el-option label="短视频" value="1"></el-option>
                      <el-option label="图片处理" value="2"></el-option>
                      <el-option label="PPT" value="3"></el-option>
                      <el-option label="CAD效果" value="4"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="任务佣金:" class="taskItem hallJg">
                    <el-input v-model="taskFrom.minPrice" placeholder="最低价">
                      <template slot="prepend">￥</template></el-input>
                    <i class="el-icon-minus"></i>
                    <el-input v-model="taskFrom.maxPrice" placeholder="最高价">
                      <template slot="prepend">￥</template></el-input>
                  </el-form-item>
                  <el-form-item label="创建时间:" class="taskItem taskItem_T">
                    <el-date-picker v-model="taskFrom.time" type="daterange" range-separator="至"
                                    start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
                  </el-form-item>
                  <div class="taskFBon">
                    <el-button icon="el-icon-refresh" @click="taskFrom={};list()">重置</el-button> <el-button
                      icon="el-icon-search" @click="list">搜索</el-button>
                  </div>
                </el-form>
              </div>
            </div>
            <div class="taskCon">
              <div class="taskCTit">
                <p>任务列表</p>
                <div class="taskCRig" @click="fetchTableData()">
                  <i class="el-icon-refresh-left"></i>
                </div>
              </div>
              <div class="taskCTable">
                <el-table :data="tableData" border>
                  <el-table-column fixed prop="bh" label="任务编号" width="180">
                  </el-table-column>
                  <el-table-column prop="stateb" label="任务状态" width="120">
                  </el-table-column>
                  <el-table-column prop="type" label="类型" width="200">
                  </el-table-column>
                  <el-table-column prop="xcon" label="需求描述" min-width="250">
                  </el-table-column>
                  <el-table-column prop="yjprice" sortable label="任务佣金" width="150">
                  </el-table-column>
                  <el-table-column prop="bzprice" sortable label="保证金" width="150">
                  </el-table-column>
                  <el-table-column prop="sjprice" sortable label="手续费" width="150">
                  </el-table-column>
                  <el-table-column prop="jgtime" sortable label="交稿时限" width="220">
                  </el-table-column>
                  <el-table-column prop="xma" label="联系人" width="120">
                    <template slot-scope="scope">
                      <p v-if="scope.row.hm">{{scope.row.hm}}</p>
                      <p v-else>{{scope.row.xm}}</p>
                    </template>
                  </el-table-column>
<!--                  <el-table-column prop="tel" label="联系人电话" width="150">-->
<!--                  </el-table-column>-->
<!--                  <el-table-column prop="lxrtel" label="联系人微信" width="150">-->
<!--                  </el-table-column>-->
                  <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                      <el-button class="app_mlTableCk" type="text" size="small"
                                 @click="detailsShowa(scope.row.id)">查看</el-button>
                      <el-dropdown class="taskdropdown"  v-if="scope.row.state==1">
                                            <span class="el-dropdown-link">
                                                更多<i class="el-icon-arrow-down el-icon--right"></i>
                                            </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item  @click.native="editorder(scope.row.id)">编辑</el-dropdown-item>
                          <el-dropdown-item  @click.native="releaseShowa(scope.row.id)">发布</el-dropdown-item>
                          <el-dropdown-item  @click.native="withdraw(scope.row.id)">关闭</el-dropdown-item>
                       </el-dropdown-menu>
                      </el-dropdown>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="app_page" v-if="tableData.length>0">
                  <el-pagination
                      @size-change="sizechange"
                      @current-change="handleCurrentChange"
                      layout="sizes, prev, pager, next"
                      :page-sizes="[10,50,80,100]" :page-size="10" :total="pagesize" :current-page="onpage">
                  </el-pagination>
                </div>
              </div>
            </div>
            <el-dialog title="任务详情" class="TaskDetails" :visible.sync="detailsShow">
              <div class="TaskDTbox" v-html="listcon.html">
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button @click="detailsShow = false" class="Password_hide">关闭</el-button>
              </div>
            </el-dialog>
            <el-dialog title="任务编辑" class="TaskDetails" :visible.sync="editShow">
              <el-form ref="editForm" :model="editForm" label-width="100px">
              <div class="editFbox">
                <div class="orderXTit">任务信息</div>
                <div class="orderFrom">
                    <el-form-item label="任务编号:" class="editFItem" style="width:100%">
                      <div class="editFbh">{{editForm.bh}}</div>
                    </el-form-item>
                    <el-form-item label=" 类型:" class="orderFItem" v-if="editForm.type==1">
                      <el-select v-model="editForm.xtype" placeholder="请选择类型" >
                        <el-option  v-for="item in data.dsp.xcon"
                                    :label="item"
                                    :value="item"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label=" 类型:" class="orderFItem" v-if="editForm.type==2">
                      <el-select v-model="editForm.xtype" placeholder="请选择类型" >
                        <el-option  v-for="item in data.tp.xcon"
                                    :label="item"
                                    :value="item"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label=" 类型:" class="orderFItem" v-if="editForm.type==3">
                      <el-select v-model="editForm.xtype" placeholder="请选择类型" >
                        <el-option  v-for="item in data.ppt.xcon"
                                    :label="item"
                                    :value="item"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label=" 类型:" class="orderFItem"  v-if="editForm.type==4">
                      <el-select v-model="editForm.xtype" placeholder="请选择类型">
                        <el-option  v-for="item in data.cad.xcon"
                                    :label="item"
                                    :value="item"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="需求描述:" class="orderFItem" prop="Requirement">
                      <el-input v-model="editForm.xcon" placeholder="一句话说明您的需求"></el-input>
                    </el-form-item>
                    <el-form-item label="需求说明:" class="editFItem" prop="illustrate">
                      <el-input type="textarea" v-model="editForm.xsm"
                                placeholder="请填写详细需求说明"></el-input>
                    </el-form-item>
                    <el-form-item label="接单要求:" class="editFItem" prop="Order_requirements">
                      <el-input type="textarea" placeholder="请填写提示接单人接单时的要求和注意事项"
                                v-model="editForm.jdyq"></el-input>
                    </el-form-item>

                    <el-form-item label="客户实付金额:" class="orderFItem">
                      <el-input v-model="editForm.sfprice" @input="sfprice" placeholder="请输入客户实付金额">
                        <template slot="append">元</template></el-input>
                    </el-form-item>
                    <el-form-item label="任务佣金:" class="orderFItem">
                      <el-input v-model="editForm.yjprice"  placeholder="请输入任务佣金">
                        <template slot="append">元</template></el-input>
                    </el-form-item>
                    <el-form-item label="保证金:" class="orderFItem">
                      <el-input v-model="editForm.bzprice"  placeholder="请输入保证金">
                        <template slot="append">元</template></el-input>
                    </el-form-item>
                    <el-form-item label="期望完成时间:" class="orderFItem" prop="lastTime">

                      <vue-flatpickr
                          v-model="editForm.jgtime"
                          :config="flatpickrConfig"
                          :placeholder="editForm.jgtimee"
                          class="el-input__inner">
                      </vue-flatpickr>
                    </el-form-item>
                    <el-form-item label="订单平台:" class="orderFItem">
                      <el-input v-model="editForm.order"  placeholder="请输入订单平台"></el-input>
                    </el-form-item>
                    <el-form-item label="订单编号:" class="orderFItem">
                      <el-input v-model="editForm.orderbh"  placeholder="请输入订单平台"></el-input>
                    </el-form-item>

                </div>
              </div>
              <div class="orderCBox" v-if="editForm.type==1">
                <div class="orderXTit">视频任务要求</div>
                <div class="orderFrom">
                  <el-form-item label="标签:" class="orderDItem">
                    <el-checkbox-group v-model="editForm.bq">
                      <el-checkbox v-for="item in data.dsp.rcon" :key="item" :label="item"
                      >{{item}}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item label="作品数量:" class="orderFItem"  prop="num">
                    <el-input v-model.number="editForm.num"
                              @input="num"
                              placeholder="">
                      <template slot="append">件</template></el-input>
                  </el-form-item>
                  <el-form-item label="视频时长:" class="orderFItem orderVTime"  prop="spsca">
                    <el-input v-model.number="editForm.spsca"
                              placeholder=" ">
                      <template slot="append">时</template></el-input>
                    <el-input v-model.number="editForm.spscb" placeholder="">
                      <template slot="append">分</template></el-input>
                    <el-input v-model.number="editForm.spscc" placeholder="">
                      <template slot="append">秒</template></el-input>
                  </el-form-item>
                  <el-form-item label="尺寸:" class="orderFItem">
                    <el-select v-model="editForm.size" placeholder="请选择尺寸">
                      <el-option v-for="item in data.dsp.size"
                                 :label="item"
                                 :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="是否提供素材:" class="orderFItem orderDx">
                    <el-radio-group v-model="editForm.sc">
                      <el-radio :label="'是'">是</el-radio>
                      <el-radio :label="'否'">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="动画/特效:" class="orderFItem orderDx">
                    <el-radio-group v-model="editForm.tx">
                      <el-radio :label="'是'">是</el-radio>
                      <el-radio :label="'否'">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="是否提供脚本:" class="orderFItem orderDx">
                    <el-radio-group v-model="editForm.jb">
                      <el-radio :label="'是'">是</el-radio>
                      <el-radio :label="'否'">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="文件上传:" class="orderFItem orderSc">

                    <el-upload
                        class="upload-demo"
                        action="/?a=add_file&action=ok&name=file"
                        :on-remove="handleRemove"
                        :file-list="fileList"
                        :on-success="handleSuccess"
                    >
                      <el-button slot="trigger" size="small" type="primary">点击上传</el-button>
                    </el-upload>
                  </el-form-item>
                </div>
              </div>
              <div class="orderCBox" v-if="editForm.type==2">
                <div class="orderXTit">图片处理任务要求</div>
                <div class="orderFrom">
                  <el-form-item label="标签:" class="orderDItem">
                    <el-checkbox-group v-model="editForm.bq">
                      <el-checkbox v-for="itema in data.tp.rcon" :key="itema" :label="itema"
                      >{{ itema}}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item label="作品数量:" class="orderFItem"  prop="num">
                    <el-input v-model.number="editForm.num"
                              @input="num"
                              placeholder="">
                      <template slot="append">件</template></el-input>
                  </el-form-item>
                  <el-form-item label="排版要求:" class="orderFItem" >
                    <el-select v-model="editForm.spsc" placeholder="排版要求">
                      <el-option  v-for="item in data.tp.size"
                                  :label="item"
                                  :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="尺寸:" class="orderFItem"  prop="num">
                    <el-input v-model="editForm.size" placeholder="">
                    </el-input>
                  </el-form-item>
                  <el-form-item label="分辨率:" class="orderFItem" >
                    <el-select v-model="editForm.pp" placeholder="排版要求">
                      <el-option  v-for="item in data.tp.ppyq"
                                  :label="item"
                                  :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="是否提供素材:" class="orderFItem orderDx">
                    <el-radio-group v-model="editForm.sc">
                      <el-radio :label="'是'">是</el-radio>
                      <el-radio :label="'否'">否</el-radio>
                    </el-radio-group>
                  </el-form-item>

                  <el-form-item label="文件上传:" class="orderFItem orderSc">

                    <el-upload
                        class="upload-demo"
                        action="/?a=add_file&action=ok&name=file"
                        :on-remove="handleRemove"
                        :file-list="fileList"
                        :on-success="handleSuccess"
                    >
                      <el-button slot="trigger" size="small" type="primary">点击上传</el-button>
                    </el-upload>
                  </el-form-item>
                </div>
              </div>
              <div class="orderCBox" v-if="editForm.type==3">
                <div class="orderXTit">PPT任务要求</div>
                <div class="orderFrom">
                  <el-form-item label="标签:" class="orderDItem">
                    <el-checkbox-group v-model="editForm.bq">
                      <el-checkbox v-for="itema in data.ppt.rcon" :key="itema" :label="itema"
                      >{{ itema}}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item label="页数:" class="orderFItem" >
                    <el-input v-model.number="editForm.num"
                              @input="num"
                              placeholder="">
                      <template slot="append">页</template></el-input>
                  </el-form-item>
                  <el-form-item label="比例:" class="orderFItem" >
                    <el-select v-model="editForm.spsc" placeholder="比例">
                      <el-option  v-for="item in data.tp.ppyq"
                                  :label="item"
                                  :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="文件格式要求:" class="orderFItem" >
                    <el-select v-model="editForm.pp" placeholder="排版要求">
                      <el-option  v-for="item in data.ppt.size"
                                  :label="item"
                                  :value="item"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="场合:" class="orderFItem" >
                    <el-input v-model.number="editForm.fbl" placeholder="请输入场合">
                    </el-input>
                  </el-form-item>

                  <el-form-item label="文件上传:" class="orderFItem orderSc">

                    <el-upload
                        class="upload-demo"
                        action="/?a=add_file&action=ok&name=file"
                        :on-remove="handleRemove"
                        :file-list="fileList"
                        :on-success="handleSuccess"
                    >
                      <el-button slot="trigger" size="small" type="primary">点击上传</el-button>
                    </el-upload>
                  </el-form-item>
                </div>
              </div>
              <div class="editFbox orderCBox">
                <div class="orderXTit">联系方式</div>
                <div class="orderFrom">
                  <el-form ref="editForm" :model="editForm" label-width="100px">
                    <el-form-item label="客户:" class="editLItem" prop="Requirement">
                      <el-input v-model="editForm.xm" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="手机:" class="editLItem" prop="Requirement">
                      <el-input v-model="editForm.tel" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="微信:" class="editLItem" prop="Requirement">
                      <el-input v-model="editForm.lxtel" placeholder=""></el-input>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
              <div class="dialog-footer">
                <el-button type="primary"  @click="addorder(1)">保存</el-button>
                <el-button @click="editShow = false;editForm=[];fileList=[]" class="Password_hide">取 消</el-button>
              </div>
              </el-form>
            </el-dialog>
            <el-dialog title="任务关闭" class="Password" :visible.sync="closeShow">
              <el-form :model="closeForm" label-width="80px">
                <el-form-item label="关闭原因">
                  <el-input type="textarea" :rows="2" placeholder="请输入内容"  v-model="closeForm.textarea"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="closeShow = false;closeForm=[]" class="Password_hide">取 消</el-button>
                <el-button type="primary" @click="closeShowa">确 定</el-button>
              </div>
            </el-dialog>
            <el-dialog title="任务发布" class="Password release" :visible.sync="releaseShow">
              <div class="relTit">
                <h4>是否发布任务？</h4>
                <p>任务佣金</p>
                <div class="relNum">
                  ￥{{releasefrom.yjprice}}
                </div>
              </div>
              <div class="relText">
                任务编号：<span>{{releasefrom.bh}} </span>创建成功 <br>
                点击“确定”后任务发布到任务大厅， 点“取消”或关闭窗口取消发布，可在任务列表中继续完成编辑。
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button @click="releaseShow = false;releasefrom=[]" class="Password_hide">取 消</el-button>
                <el-button type="primary" @click="releaseShowb(releasefrom.id)">确 定</el-button>
              </div>
            </el-dialog>
          </el-main>
        </div>
      </div>
    </el-container>
  </el-container>
</template>

<script>
import axios from "axios";
import VueFlatpickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/l10n/zh.js';
export default {
  // 指定 name 选项的另好处是便于调试。有名字的组件有更友好的警告信息.
  // 另外，当在有 vue-devtools，未命名组件将显示成 <AnonymousComponent>，这很没有语义。通过提供 name 选项，可以获得更有语义信息的组件树。
  name: 'tasklist',
  components: {
    VueFlatpickr
  },
  data() {
    return {
      flatpickrConfig: {
        allowInput: false,
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
        time_24hr: true,
        minDate: "today", // 设置只能选择今天之后的日期
        locale: 'zh' // 使用中文
      },
      asideId: 6,
      value1: '',
      on_orderId: 2,
      app_asideId: 6,
      taskFrom: [],
      tableData: [],
      fileList: [],
      todos:[],
      onpage:0,
      pagesize:0,
      detailsShow:false,
      listcon: [],
      editForm: [],
      data: [],
      editShow:false,
      closeForm: [],
      closeShow:false,
      releasefrom: [],
      releaseShow:false,
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('savePageState', {
      pageName: "tasklist",
      pageState: {
        taskFrom: this.taskFrom,
        onpage: this.onpage,
        pagesize: this.pagesize
      }
    });
    next();
  },
  // 这里为了测试被切换的组件去哪了
  mounted() {
    this.todos=this.$store.state.tags
    let todos= this.todos
    console.log(this.todos);
    let index =todos.findIndex(note => note.path === "tasklist");
    if(index>=0){
      this.activeTabIndex=index
    }else{
      const newNote = {
        title: "任务列表",
        path: 'tasklist'
      }
      this.$store.state.tags.push(newNote);
      this.activeTabIndex=this.todos.length - 1
    }
    this.userpath=this.$store.state.userpath
    this.fetchTableData();
    let savedState = this.$store.state.pageState["tasklist"];
    console.log(savedState)
    if (savedState) {
      this.taskFrom=savedState.taskFrom
      this.pagesize=savedState.pagesize
      this.onpage=savedState.onpage
      this.handleCurrentChange(this.onpage)
    }
  },
  methods: {
    sfprice(value){
      console.log(this.data.yjset)
      // 清理非数字字符（除了点号用于小数）
      const cleanedValue = value.replace(/[^\d.]/g, '');
      if (!cleanedValue || cleanedValue === '.') {
        this.editForm.sfprice = 0; // 或者你想要的默认值
        return;
      }
      // 确保只有一个小数点
      const parts = cleanedValue.split('.');
      const mainPart = parts[0];
      const decimalPart = parts[1] ? parts[1].slice(0, 2) : ''; // 限制小数位数为两位
      const formattedValue = `${mainPart}.${decimalPart}`;
      if (formattedValue !== value) {
        this.editForm.sfprice = parseFloat(formattedValue);
        this.editForm.yjprice = parseFloat(formattedValue*this.data.yjset.title).toFixed(2);
        this.editForm.bzprice = parseFloat(this.editForm.yjprice*this.data.yjset.title).toFixed(2);
      }
    },
    handleRemove(file, fileList) {
      console.log(fileList)
      console.log(this.fileList)
      console.log('remove', file, fileList);
      this.demandForm.file='';
    },
    handleSuccess(response, file, fileList) {
      console.log(fileList)
      console.log(this.fileList)
      console.log('success', response, file, fileList);
      this.demandForm.file=fileList;
      console.log(this.demandForm.file)
      // 这里可以根据你的需求处理上传成功后的逻辑
      // 例如，你可能想要清空 fileList 或更新 Addform 中的某些字段
    },
    num(value){
      // 清理非数字字符（除了点号用于小数）
      const cleanedValue = value.replace(/[^\d.]/g, '');
      if (!cleanedValue || cleanedValue === '.') {
        this.demandForm.num = 0; // 或者你想要的默认值
        return;
      }
      const parts = cleanedValue.split('.');
      const mainPart = parts[0];
      let decimalPart = parts[1] ? parts[1].slice(0, 2) : ''; // 限制小数位数为两位
      if (decimalPart === '00' || !decimalPart) {
        decimalPart = '';
      }
      const formattedValue = `${mainPart}${decimalPart ? `.${decimalPart}` : ''}`;
      const numericValue = parseFloat(formattedValue);
      if (decimalPart === '') {
        this.demandForm.num = Math.floor(numericValue); // 或者使用 parseInt(numericValue, 10)
      } else {
        this.demandForm.num = numericValue;
      }
    },
    switchTab(index) {
      this.$router.push(this.todos[index].path); // 使用push保留历史记录，或使用replace不保留
    },
    removeTodo(index) {
      this.todos.splice(index, 1);
      this.$forceUpdate();
      if(index==this.activeTabIndex){
        this.$router.push(this.todos[index].path);
      }else if(index<this.activeTabIndex){
        this.activeTabIndex=this.activeTabIndex-1
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    on_order(e) {
      console.log('e', e)
      this.on_orderId = e
      if (e == 1) {
        this.$router.push('/Publish_task')
      } else if (e == 2) {
        this.$router.push('/tasklist')
      } else if (e == 3) {
        this.$router.push('/order')
      } else if (e == 4) {
        this.$router.push('/consumer')
      }else if (e == 5) {
        this.$router.push('/endorder')
      }
    },
    fetchTableData() {
      console.log(123)
      axios.get(this.$store.state.apiUrl+'/?a=ajax_select&m=tasklist')
          .then(response => {
            this.tableData = response.data.arr;
            console.log(this.tableData[0].state)
            this.pagesize = response.data.pagesize;
          })
          .catch(error => {
            // 处理错误情况
            console.error("There was an error!", error);
          });

    },
    list(){
      const formDataa = {
        ...this.taskFrom // 使用展开运算符来复制this.demandForm的所有属性
      };
      axios.post(this.$store.state.apiUrl+'/?a=ajax_select&m=tasklist', formDataa, {
        headers: {
          'Content-Type': 'application/json' // 设置请求头为JSON
        }
      })
          .then(response => {
            const data=response.data
            if(data.status==1){
              this.tableData=data.arr
              this.pagesize=data.pagesize
            }else{
              this.$message({
                type: 'info',
                message: data.msg
              });
            }
          })
          .catch(error => {
            // 处理错误情况
            console.error("There was an error!", error);
          });
    },
    fetchTableDataa() {
      console.log(123)
      axios.post(this.$store.state.apiUrl+'/?a=ajax_select&m=publish_task')
          .then(response => {
            this.data = response.data;
            console.log(this.data.dsp.rcon)
          })
          .catch(error => {
            console.error("There was an error!", error);
          });
    },
    sizechange(val){
      this.taskFrom.size = val
      this.taskFrom.page = 0
      const formDataa = {
        ...this.taskFrom // 使用展开运算符来复制this.demandForm的所有属性
      };
      axios.post(this.$store.state.apiUrl+'/?a=ajax_select&m=tasklist', formDataa, {
        headers: {
          'Content-Type': 'application/json' // 设置请求头为JSON
        }
      })
          .then(response => {
            const data=response.data
            if(data.status==1){
              this.tableData=data.arr
              this.pagesize=data.pagesize
            }else{
              this.$message({
                type: 'info',
                message: data.msg
              });
            }
          })
          .catch(error => {
            // 处理错误情况
            console.error("There was an error!", error);
          });
    },
    handleCurrentChange(val){
      this.taskFrom.page = val
      const formDataa = {
        ...this.taskFrom // 使用展开运算符来复制this.demandForm的所有属性
      };
      axios.post(this.$store.state.apiUrl+'/?a=ajax_select&m=tasklist', formDataa, {
        headers: {
          'Content-Type': 'application/json' // 设置请求头为JSON
        }
      })
          .then(response => {
            const data=response.data
            if(data.status==1){
              this.tableData=data.arr
              this.pagesize=data.pagesize
            }else{
              this.$message({
                type: 'info',
                message: data.msg
              });
            }
          })
          .catch(error => {
            // 处理错误情况
            console.error("There was an error!", error);
          });
    },
    detailsShowa(e){
      axios.get(this.$store.state.apiUrl+'/?a=ajax_select&m=order_info&id='+e)
          .then(response => {
            this.listcon = response.data.arr;
            console.log(this.listcon.price)
            this.detailsShow = true;
          })
          .catch(error => {
            // 处理错误情况
            console.error("There was an error!", error);
          });
    },
    editorder(e){
      this.fetchTableDataa();
      const formDataa = {};
      formDataa.id=e
      axios.post(this.$store.state.apiUrl+'/?a=ajax_select&m=order_infoa',formDataa,{
        headers: {
          'Content-Type': 'application/json' // 设置请求头为JSON
        }
      })
          .then(response => {
            const data=response.data
            console.log(data.arr.jgtime)
            if(data.status==1){
              this.editShow=true;
              this.editForm=data.arr;
            }else {
              this.$message({
                type: 'info',
                message: data.msg
              });
            }

            console.log(this.editForm)
            console.log(this.editForm.jgtime)
          })
          .catch(error => {
            // 处理错误情况
            console.error("There was an error!", error);
          });
    },
    addorder(e){
      var editForma=this.editForm
      if(!editForma.xtype){
        this.$message({
          type: 'info',
          message: '请选择类型'
        });
        return false
      }
      if(!editForma.xcon){
        this.$message({
          type: 'info',
          message: '请输入需求描述'
        });
        return false
      }
      if(!editForma.orderbh){
        this.$message({
          type: 'info',
          message: '请输入订单编号'
        });
        return false
      }
      if(!editForma.xsm){
        this.$message({
          type: 'info',
          message: '请输入需求说明'
        });
        return false
      }
      if(!editForma.yjprice){
        this.$message({
          type: 'info',
          message: '请输入任务佣金'
        });
        return false
      }
      if(!editForma.bzprice){
        this.$message({
          type: 'info',
          message: '请输入保证金'
        });
        return false
      }
      if(!editForma.jgtime){
        this.$message({
          type: 'info',
          message: '请选择交稿时限'
        });
        return false
      }
      if(!editForma.xm){
        this.$message({
          type: 'info',
          message: '请输入联系名称'
        });
        return false
      }
      if(!editForma.tel){
        this.$message({
          type: 'info',
          message: '请输入联系手机号码'
        });
        return false
      }
      editForma.lx=e
      editForma.orderid=editForma.id
      const formData = {
        ...editForma // 使用展开运算符来复制this.demandForm的所有属性
      };
      axios.post(this.$store.state.apiUrl+'/?a=ajax_add&m=order', formData, {
        headers: {
          'Content-Type': 'application/json' // 设置请求头为JSON
        }
      })
      .then(response => {
            const data=response.data
            if(data.status==1){
              this.$message({
                type: 'success',
                message: '操作成功'
              });
              this.handleCurrentChange(this.onpage)
              this.editShow = false
            }else{
              this.$message({
                type: 'info',
                message: data.msg
              });
            }
          })
      .catch(error => {
            // 处理错误情况
            console.error("There was an error!", error);
          });
    },
    withdraw(e){
      this.closeForm.id=e;
      this.closeShow=true;
    },
    closeShowa(){
      const formDataa = {
        ...this.closeForm // 使用展开运算符来复制this.demandForm的所有属性
      };
      axios.post(this.$store.state.apiUrl+'/?a=ajax_edit&m=order_withdrawa',formDataa,{
        headers: {
          'Content-Type': 'application/json' // 设置请求头为JSON
        }
      })
          .then(response => {
            const data=response.data
            if(data.status==1){
              this.$message({
                type: 'success',
                message: "操作成功"
              });
              this.handleCurrentChange(this.onpage)
              this.closeShow=false;
              this.closeForm=[];
            }else {
              this.$message({
                type: 'info',
                message: data.msg
              });
            }
          })
          .catch(error => {
            // 处理错误情况
            console.error("There was an error!", error);
          });
    },
    releaseShowa(e){
      const formDataa = {};
      formDataa.id=e
      formDataa.type='fb'
      axios.post(this.$store.state.apiUrl+'/?a=ajax_select&m=order_infoa',formDataa,{
        headers: {
          'Content-Type': 'application/json' // 设置请求头为JSON
        }
      })
          .then(response => {
            const data=response.data
            console.log(data)
            if(data.status==1){
              this.releaseShow=true;
              this.releasefrom=data.arr;
            }else {
              this.$message({
                type: 'info',
                message: data.msg
              });
            }
          })
          .catch(error => {
            // 处理错误情况
            console.error("There was an error!", error);
          });
    },
    releaseShowb(e){
      const formDataa = {};
      formDataa.id=e
      axios.post(this.$store.state.apiUrl+'/?a=ajax_edit&m=orderfb',formDataa,{
        headers: {
          'Content-Type': 'application/json' // 设置请求头为JSON
        }
      })
          .then(response => {
            const data=response.data
            console.log(data)
            if(data.status==1){
              this.$message({
                type: 'success',
                message: "操作成功"
              });
              this.releaseShow=false;
              this.releasefrom=[];
              this.handleCurrentChange(this.onpage)
            }else {
              this.$message({
                type: 'info',
                message: data.msg
              });
            }
          })
          .catch(error => {
            // 处理错误情况
            console.error("There was an error!", error);
          });
    }
  },
}
</script>

<style>
.dialog-footer{
  text-align: center;
  margin-top: 10px;
}
</style>